import { useMutation } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';

const invalidateAccess = async ({ sessionId, formIds }: { sessionId: number; formIds: string[] }) => {
  const { data: responseData } = await apiClient.patch(`session/${sessionId}/access-link`, {
    formIds,
  });
  return responseData.data;
};

const useInvalidateAccess = () => {
  return useMutation({
    mutationFn: invalidateAccess,
  });
};

export default useInvalidateAccess;
